<template>
    <div>
        <loading :active.sync="is_loading" 
        :can-cancel="true" 
        :is-full-page="true">
        </loading>
        <SemNavbar/>
        <main class="main" style="margin-top: 70px;">
            <section id="dashboard" class="p-3">
                <div class="accordion" id="mode-data">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                Realtime
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show">
                            <div class="accordion-body">
                                <div class="card mb-3">
                                    <div class="card-title px-3">
                                        <img src="../../assets/icon/line-graph-icon.png" alt="" style="width: 40px;" />
                                        TMA Sungai Cileungsi (Jembatan Wika)
                                    </div>
                                    <div class="card-body">
                                        <line-chart :chart-data="charts_1" :options="chart_options_telemetri"></line-chart>
                                    </div>
                                </div>
                                <div class="card mb-3">
                                    <div class="card-title px-3">
                                        <img src="../../assets/icon/line-graph-icon.png" alt="" style="width: 40px;" />
                                        TMA Sungai Cileungsi (Villa Nusa Indah)
                                    </div>
                                    <div class="card-body">
                                        <line-chart :chart-data="charts_2" :options="chart_options_telemetri"></line-chart>
                                    </div>
                                </div>
                                <div class="card mb-3">
                                    <div class="card-title px-3">
                                        <img src="../../assets/icon/line-graph-icon.png" alt="" style="width: 40px;" />
                                        TMA Bendung Cikeas (Koja)
                                    </div>
                                    <div class="card-body">
                                        <line-chart :chart-data="charts_3" :options="chart_options_telemetri"></line-chart>
                                    </div>
                                </div>
                                <div class="card mb-3">
                                    <div class="card-title px-3">
                                        <img src="../../assets/icon/line-graph-icon.png" alt="" style="width: 40px;" />
                                        TMA Bendung Bekasi
                                    </div>
                                    <div class="card-body">
                                        <line-chart :chart-data="charts_4" :options="chart_options_telemetri"></line-chart>
                                    </div>
                                </div>
                                <div class="card mb-3">
                                    <div class="card-title px-3">
                                        <img src="../../assets/icon/line-graph-icon.png" alt="" style="width: 40px;" />
                                        TMA Hulu Sungai Cikarang
                                    </div>
                                    <div class="card-body">
                                        <line-chart :chart-data="charts_5" :options="chart_options_telemetri"></line-chart>
                                    </div>
                                </div>
                                <div class="card mb-3">
                                    <div class="card-title px-3">
                                        <img src="../../assets/icon/line-graph-icon.png" alt="" style="width: 40px;" />
                                        TMA Bendung Cikarang
                                    </div>
                                    <div class="card-body">
                                        <line-chart :chart-data="charts_6" :options="chart_options_telemetri"></line-chart>
                                    </div>
                                </div>
                                <div class="card mb-3">
                                    <div class="card-title p-3 pb-0">
                                        Peta Sebaran Pos Telemetri
                                    </div>
                                    <div class="card-body">
                                        <template v-if="single_location_show">
                                            <div class="card">
                                                <div class="card-title p-3 justify-content-between">
                                                    {{ location_name }}
                                                    <a href="" @click.prevent="single_location_show = false"><i class="fa fa-times"></i></a>
                                                </div>
                                                <div class="card-body">
                                                    <div class="clearfix"></div>
                                                    <line-chart :chart-data="charts_7" :options="chart_options_telemetri"></line-chart>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <GmapMap
                                                :center="{lat:this.lat, lng:this.lng}"
                                                :zoom="9"
                                                map-type-id="roadmap"
                                                style="width: 100%; height: 400px"
                                                ref="peta">
                                                    <GmapMarker
                                                        v-for="marker in filtered_locations"
                                                        :key="marker.id"
                                                        :icon="{url:defineIcon()}"
                                                        :clickable="true"
                                                        :position="{lat: parseFloat(marker.lat), lng:parseFloat(marker.lng)}"
                                                        :title="defineTitle(marker)"
                                                        @click="() => { single_location_show = true; changeLocation(marker.id, 'charts_7') }"
                                                    >
                                                    </GmapMarker>
                                            </GmapMap>
                                            <MapLegend css="position: static; right: 0; bottom: 0"></MapLegend>
                                        </template>
                                    </div>
                                </div>
                                <div class="card" style="min-height: 500px;">
                                    <div class="card-body">
                                        <!-- Title -->
                                        <div class="card-title text-black" style="justify-content: space-between; align-items: center">
                                            <div>
                                                <img src="../../assets/icon/line-graph-icon.png" alt="" style="width: 40px;">
                                                <strong>TMA Waduk Ir. H. Djuanda (mdpl)</strong>
                                            </div>
                                            <select class="form-select" v-model="djuanda_mode" style="width: 130px">
                                                <option value="realtime">Realtime</option>
                                                <option value="manual">Manual</option>
                                            </select>
                                        </div>
                                        <line-chart :chart-data="charts" :options="chart_options" v-if="djuanda_mode === 'manual'"></line-chart>
                                        <line-chart :chart-data="realtime_charts" :options="chart_options" v-else></line-chart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- MANUAL -->
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                            Manual
                        </button>
                        </h2>
                        <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse show">
                            <div class="accordion-body">
                                <div class="row">
                                    <!-- Card 2 -->
                                    <div class="col-lg-12 col-xl-6">
                                        <div class="card" style="height: 500px;">
                                            <div class="card-body">
                                                <!-- Graph -->
                                                <p class="card-title text-black">
                                                    <img src="../../assets/icon/bar-graph-icon.png" alt="" style="width: 40px;">
                                                    <strong>Debit Air ke PAB (m<sup>3</sup>/detik)</strong>
                                                </p>
                                                <div style="height: 380px" class="overflow-auto">
                                                    <div class="border p-3 mb-3" v-for="index in debit_pab.syphon_bekasi.length" :key="index">
                                                        <i class="fa fa-calendar me-2"></i> <b>{{ (debit_pab.syphon_bekasi[index] ? debit_pab.syphon_bekasi[index][0]:0) | formatTime}}</b>
                                                        <table class="table">
                                                            <tbody>
                                                                <tr>
                                                                    <th width="70%">Syphon Bekasi</th>
                                                                    <td class="text-end">{{ debit_pab.syphon_bekasi[index] ? debit_pab.syphon_bekasi[index][1]:0 }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>
                                                                        <span class="bg-warning border border-light rounded-circle" style="width:12px;height:12px;display:inline-block;background-color: #FF642E!important">
                                                                            <span class="visually-hidden">&nbsp;</span>
                                                                        </span>
                                                                        Buaran
                                                                    </th>
                                                                    <td class="text-end">{{ debit_pab.buaran[index] ? debit_pab.buaran[index][1]:0 }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>
                                                                        <span class="bg-success border border-light rounded-circle" style="width:12px;height:12px;display:inline-block;background-color:#9CD326!important">
                                                                            <span class="visually-hidden">&nbsp;</span>
                                                                        </span>
                                                                        Pulogadung
                                                                    </th>
                                                                    <td class="text-end">{{ debit_pab.pulogadung[index] ? debit_pab.pulogadung[index][1]:0 }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>
                                                                        <span class="bg-info border border-light rounded-circle" style="width:12px;height:12px;display:inline-block">
                                                                            <span class="visually-hidden">&nbsp;</span>
                                                                        </span>
                                                                        Pejompongan
                                                                    </th>
                                                                    <td class="text-end">{{ debit_pab.pejompongan[index] ? debit_pab.pejompongan[index][1]:0 }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Grafik</th>
                                                                    <td>
                                                                        <div class="progress" style="height:10px">
                                                                            <div
                                                                                class="progress-bar bg-warning"
                                                                                role="progressbar" 
                                                                                :style="'width: '+getDebitPercentage(debit_pab, index, 0)+'%; background-color: #FF642E!important'"
                                                                                :aria-valuenow="getDebitPercentage(debit_pab, index, 0)" 
                                                                                aria-valuemin="0" 
                                                                                aria-valuemax="100"></div>
                                                                            <div
                                                                                class="progress-bar bg-success"
                                                                                role="progressbar"
                                                                                :style="'width: '+getDebitPercentage(debit_pab, index, 1)+'%;background-color:#9CD326!important'" 
                                                                                :aria-valuenow="getDebitPercentage(debit_pab, index, 1)" 
                                                                                aria-valuemin="0" 
                                                                                aria-valuemax="100"></div>
                                                                            <div 
                                                                                class="progress-bar bg-info" 
                                                                                role="progressbar" 
                                                                                :style="'width: '+getDebitPercentage(debit_pab, index, 2)+'%'" 
                                                                                :aria-valuenow="getDebitPercentage(debit_pab, index, 2)" 
                                                                                aria-valuemin="0" 
                                                                                aria-valuemax="100"></div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- GRAPH ROW 2 -->
                                <div class="row">
                                    <div class="col-lg-12 col-xl-8">
                                        <div class="card">
                                            <div class="card-body" style="overflow: auto">
                                                <div class="card-title">
                                                    <img src="../../assets/icon/bar-graph-icon.png" alt="" style="width: 40px;">
                                                    <strong>Air Waduk Ir. Djuanda (m<sup>3</sup>/detik)</strong>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="border p-3 mb-3">
                                                            <i class="fa fa-calendar me-2"></i> <b>{{ awd.akw[0].length > 0 ? awd.akw[0][0]:'' }}</b>
                                                            <table class="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <th>Air Masuk</th>
                                                                        <td>{{ awd.am[0].length > 0 ? awd.am[0][1]:'' }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Cirata</th>
                                                                        <td>{{ awd.akc[0].length > 0 ? awd.akc[0][1]:'' }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Masuk Lokal</th>
                                                                        <td>{{ awd.aml[0].length > 0 ? awd.aml[0][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Waduk</th>
                                                                        <td>{{ awd.akw[0].length > 0 ? awd.akw[0][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Turbin</th>
                                                                        <td>{{ awd.aktb[0].length > 0 ? awd.aktb[0][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>HJV</th>
                                                                        <td>{{ awd.hjv[0].length > 0 ? awd.hjv[0][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Limpasan</th>
                                                                        <td>{{ awd.limpas[0].length > 0 ? awd.limpas[0][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Grafik</th>
                                                                        <td><peity :type="'bar'" :options="{ 'fill': ['#579BFC', '#FF642E']}" :data="awd.am[0][1]+','+awd.akw[0][1]"></peity></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div class="border p-3 mb-3">
                                                            <i class="fa fa-calendar me-2"></i> <b>{{ awd.akw[1].length > 0 ? awd.akw[1][0]:'' }}</b>
                                                            <table class="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <th>Air Masuk</th>
                                                                        <td>{{ awd.am[1].length > 0 ? awd.am[1][1]:'' }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Cirata</th>
                                                                        <td>{{ awd.akc[1].length > 0 ? awd.akc[1][1]:'' }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Masuk Lokal</th>
                                                                        <td>{{ awd.aml[1].length > 0 ? awd.aml[1][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Waduk</th>
                                                                        <td>{{ awd.akw[1].length > 0 ? awd.akw[1][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Turbin</th>
                                                                        <td>{{ awd.aktb[1].length > 0 ? awd.aktb[1][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>HJV</th>
                                                                        <td>{{ awd.hjv[1].length > 0 ? awd.hjv[1][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Limpasan</th>
                                                                        <td>{{ awd.limpas[1].length > 0 ? awd.limpas[1][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Grafik</th>
                                                                        <td><peity :type="'bar'" :options="{ 'fill': ['#579BFC', '#FF642E']}" :data="awd.am[0][1]+','+awd.akw[0][1]"></peity></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div class="border p-3 mb-3">
                                                            <i class="fa fa-calendar me-2"></i> <b>{{ awd.akw[2].length > 0 ? awd.akw[2][0]:'' }}</b>
                                                            <table class="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <th>Air Masuk</th>
                                                                        <td>{{ awd.am[2].length > 0 ? awd.am[2][1]:'' }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Cirata</th>
                                                                        <td>{{ awd.akc[2].length > 0 ? awd.akc[2][1]:'' }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Masuk Lokal</th>
                                                                        <td>{{ awd.aml[2].length > 0 ? awd.aml[2][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Waduk</th>
                                                                        <td>{{ awd.akw[2].length > 0 ? awd.akw[2][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Air Keluar Turbin</th>
                                                                        <td>{{ awd.aktb[2].length > 0 ? awd.aktb[2][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>HJV</th>
                                                                        <td>{{ awd.hjv[2].length > 0 ? awd.hjv[2][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Limpasan</th>
                                                                        <td>{{ awd.limpas[2].length > 0 ? awd.limpas[2][1]:''  }}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>Grafik</th>
                                                                        <td><peity :type="'bar'" :options="{ 'fill': ['#579BFC', '#FF642E']}" :data="awd.am[0][1]+','+awd.akw[0][1]"></peity></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-xl-4">
                                        <div class="card">
                                            <div class="card-body">
                                                <p class="card-title">
                                                    <img src="../../assets/icon/bar-graph-icon.png" alt="" style="width: 40px;">
                                                    <strong>Bendung Curug (m<sup>3</sup>/detik)</strong>
                                                </p>
                                                <div class="row">
                                                    <div class="col-12">
                                                        Last Update: <b>{{ curug_last_update | formatTime }}</b>
                                                    </div>
                                                </div>
                                                <!-- TMA -->
                                                <div class="row mt-4">
                                                    <div class="col-md-8">{{ curug_tma.title }}</div>
                                                    <div class="col-md-4"><span class="float-end"><b>{{ curug_tma.data[curug_tma.data.length - 1] }}</b></span></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12" ref="spark_wrap">
                                                        <sparkline :width="sparkWidth">
                                                            <sparklineBar
                                                            :data="curug_tma.data"
                                                            :margin="2"
                                                            :limit="curug_tma.data.length"
                                                            :styles="spark_style"
                                                            :refLineStyles="{}" />
                                                        </sparkline>
                                                    </div>
                                                </div>

                                                <!-- VOLUME -->
                                                <div class="row mt-3">
                                                    <div class="col-md-8">{{ curug_volume.title }}</div>
                                                    <div class="col-md-4"><span class="float-end"><b>{{ curug_volume.data[curug_volume.data.length - 1] }}</b></span></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12" ref="spark_wrap">
                                                        <sparkline :width="sparkWidth">
                                                            <sparklineBar
                                                            :data="curug_volume.data"
                                                            :margin="2"
                                                            :limit="curug_volume.data.length"
                                                            :styles="spark_style"
                                                            :refLineStyles="{}" />
                                                        </sparkline>
                                                    </div>
                                                </div>

                                                <!-- Q1 -->
                                                <div class="row mt-3">
                                                    <div class="col-md-8">{{ curug_q1.title }}</div>
                                                    <div class="col-md-4"><span class="float-end"><b>{{ curug_q1.data[curug_q1.data.length - 1] }}</b></span></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12" ref="spark_wrap">
                                                        <sparkline :width="sparkWidth">
                                                            <sparklineBar
                                                            :data="curug_q1.data"
                                                            :margin="2"
                                                            :limit="curug_q1.data.length"
                                                            :styles="spark_style"
                                                            :refLineStyles="{}" />
                                                        </sparkline>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ===== TABLE 3 =====-->
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="card">
                                            <div class="card-body" style="overflow: auto">
                                                <!-- Title -->
                                                <p class="card-title text-black">
                                                    <img src="../../assets/icon/table-icon.png" alt="" style="width: 40px;">
                                                    <strong>Data Bendung</strong>
                                                </p>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <table class="table table-hover table-responsive">
                                                            <thead>
                                                                <tr>
                                                                    <th>Bendung</th>
                                                                    <th v-for="(heading, key) in box_data_bendung.heading" :key="key" @dblclick="setEditable($event)" @keypress="updateHeading($event)" @keydown="removeEditable($event)" :id="key" v-html="heading"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <th>Q Sungai</th>
                                                                    <td v-for="(value, key) in box_data_bendung.data.row_1" :key="key" :id="key" class="data-column">
                                                                        <span>{{ value }}</span>
                                                                        <a href="#" class="btn btn-success btn-sm ms-1 edit-btn" @click.prevent="showSelect(key)"><i class="fa fa-pen"></i></a>
                                                                        <select style="width: 100px; display: none" class="mb-1">
                                                                            <optgroup v-for="(periodic, location_name) in periodics" :key="periodic.location_id" :label="location_name">
                                                                                <option v-for="periodic_data in periodic" :value="periodic_data.id" :key="periodic_data.id">{{ periodic_data.name }}</option>
                                                                            </optgroup>
                                                                        </select>
                                                                        <a href="#" class="btn btn-primary btn-sm update-btn" @click.prevent="updateColumn(key)"><i class="fa fa-save"></i></a>
                                                                        <a href="#" class="btn btn-danger btn-sm ms-1 update-btn" @click.prevent="hideSelect(key)"><i class="fa fa-times"></i></a>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Q Tersedia</th>
                                                                    <td v-for="(value, key) in box_data_bendung.data.row_2" :key="key" :id="key" class="data-column">
                                                                        <span>{{ value }}</span>
                                                                        <a href="#" class="btn btn-success btn-sm ms-1 edit-btn" @click.prevent="showSelect(key)"><i class="fa fa-pen"></i></a>
                                                                        <select style="width: 100px; display: none" class="mb-1">
                                                                            <optgroup v-for="(periodic, location_name) in periodics" :key="periodic.location_id" :label="location_name">
                                                                                <option v-for="periodic_data in periodic" :value="periodic_data.id" :key="periodic_data.id">{{ periodic_data.name }}</option>
                                                                            </optgroup>
                                                                        </select>
                                                                        <a href="#" class="btn btn-primary btn-sm update-btn" @click.prevent="updateColumn(key)"><i class="fa fa-save"></i></a>
                                                                        <a href="#" class="btn btn-danger btn-sm ms-1 update-btn" @click.prevent="hideSelect(key)"><i class="fa fa-times"></i></a>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Q Dimanfaatkan</th>
                                                                    <td v-for="(value, key) in box_data_bendung.data.row_3" :key="key" :id="key" class="data-column">
                                                                        <span>{{ value }}</span>
                                                                        <a href="#" class="btn btn-success btn-sm ms-1 edit-btn" @click.prevent="showSelect(key)"><i class="fa fa-pen"></i></a>
                                                                        <select style="width: 100px; display: none" class="mb-1">
                                                                            <optgroup v-for="(periodic, location_name) in periodics" :key="periodic.location_id" :label="location_name">
                                                                                <option v-for="periodic_data in periodic" :value="periodic_data.id" :key="periodic_data.id">{{ periodic_data.name }}</option>
                                                                            </optgroup>
                                                                        </select>
                                                                        <a href="#" class="btn btn-primary btn-sm update-btn" @click.prevent="updateColumn(key)"><i class="fa fa-save"></i></a>
                                                                        <a href="#" class="btn btn-danger btn-sm ms-1 update-btn" @click.prevent="hideSelect(key)"><i class="fa fa-times"></i></a>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Q Limpasan</th>
                                                                    <td v-for="(value, key) in box_data_bendung.data.row_4" :key="key" :id="key" class="data-column">
                                                                        <span>{{ value }}</span>
                                                                        <a href="#" class="btn btn-success btn-sm ms-1 edit-btn" @click.prevent="showSelect(key)"><i class="fa fa-pen"></i></a>
                                                                        <select style="width: 100px; display: none" class="mb-1">
                                                                            <optgroup v-for="(periodic, location_name) in periodics" :key="periodic.location_id" :label="location_name">
                                                                                <option v-for="periodic_data in periodic" :value="periodic_data.id" :key="periodic_data.id">{{ periodic_data.name }}</option>
                                                                            </optgroup>
                                                                        </select>
                                                                        <a href="#" class="btn btn-primary btn-sm update-btn" @click.prevent="updateColumn(key)"><i class="fa fa-save"></i></a>
                                                                        <a href="#" class="btn btn-danger btn-sm ms-1 update-btn" @click.prevent="hideSelect(key)"><i class="fa fa-times"></i></a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>        
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>
<script>
    import axios from 'axios' 
    import SemNavbar from '../../components/SemNavbar.vue'
    import LineChart from '../../components/chart/LineChart.vue'
    import Sparkline from 'vue-sparklines'
    import Peity from 'vue-peity';
    import moment from 'moment'
    import Loading from 'vue-loading-overlay'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    import MapLegend from '../../components/MapLegend.vue'

    const isMobile = window.innerWidth <= 768;

    export default{
        name: 'Dashboard',
        components:{
            SemNavbar,
            LineChart,
            Sparkline,
            Peity,
            Loading,
            VueSlickCarousel,
            MapLegend
        },
        data(){
            return{
                auto_ref: null,
                is_loading: false,
                name: '',
                token:'',
                access: [],
                chart_styles: {
                    height: "300px"
                },
                chart_options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: 8,
                                maxRation: isMobile ? 90: 0,
                                minRotation: isMobile ? 90: 0
                            }
                        }],
                    },
                    legend: {
                        display: true,
                        position: 'top',
                        labels: {
                            boxWidth: 12,
                            padding: 15
                        }
                    }
                },
                chart_options_telemetri: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: 8,
                                maxRation: isMobile ? 90: 0,
                                minRotation: isMobile ? 90: 0,
                                fontSize: 10
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: "left",
                            id: "y-axis-1",
                        }]
                    },
                    legend: {
                        labels: {
                            boxWidth: 12
                        }
                    }
                },
                realtime_charts: {},
                charts: {},
                debit_pab: {
                    buaran: [],
                    pulogadung: [],
                    pejompongan: [],
                    syphon_bekasi: []
                },
                curug_last_update: null,
                curug_q1: {data: []},
                curug_tma: {data: []},
                curug_volume: {data: []},
                box_data_bendung: {
                    heading: {},
                    data: {}
                },
                awd: {
                    am: [],
                    akc: [],
                    aml: [],
                    akw: [],
                    aktb: [],
                    hjv: [],
                    limpas: []
                },
                spMargin4: 1,
                spark_style: {
                    fill: '#54a5ff',
                },
                spLineStyles4: {
                    stroke: '#d14'
                },
                spRefLineStyles4: {
                },
                len: '',
                index_array: 1,
                sparkWidth: 0,
                role: '',
                periodics: [],
                djuanda_mode: 'realtime',
                charts_1: {
                    labels: [],
                    datasets: []
                },
                charts_2: {
                    labels: [],
                    datasets: []
                },
                charts_3: {
                    labels: [],
                    datasets: []
                },
                charts_4: {
                    labels: [],
                    datasets: []
                },
                charts_5: {
                    labels: [],
                    datasets: []
                },
                charts_6: {
                    labels: [],
                    datasets: []
                },
                charts_7: {
                    labels: [],
                    datasets: []
                },
                markers: [],
                lat: -6.5341128, 
                lng: 107.3428813,
                locations: [],
                filtered_locations: [],
                single_location_show: false,
                location_name: '',
                opened_tab: []
            }
        },
        methods: {
            getDebitPercentage(debit_pab, index, i){
                const total = parseFloat(debit_pab.buaran[index] ? debit_pab.buaran[index][1]:0) + parseFloat(debit_pab.pulogadung[index] ? debit_pab.pulogadung[index][1]:0) + parseFloat(debit_pab.pejompongan[index] ? debit_pab.pejompongan[index][1]:0);
                let value = 0;
                switch(i){
                    case 0:
                        var buaran = parseFloat(debit_pab.buaran[index] ? debit_pab.buaran[index][1]:0);
                        value = buaran / total * 100;
                        break;

                    case 1:
                        var pulogadung = parseFloat(debit_pab.pulogadung[index] ? debit_pab.pulogadung[index][1]:0);
                        value = pulogadung / total * 100;
                        break;

                    case 2:
                        var pejompongan = parseFloat(debit_pab.pejompongan[index] ? debit_pab.pejompongan[index][1]:0);
                        value = pejompongan / total * 100;
                        break;
                }

                return value;
            },
            getDataDjuandaRealtime(){
                this.token = localStorage.getItem('token');

                axios.get(this.$endpoints.operasi + 'waduk-djuanda?token=' + this.token)
                .then((response) =>{
                    this.realtime_charts = response.data.data;
                });
            },
            getData(){
                this.name = localStorage.getItem('name');
                this.token = localStorage.getItem('token');
                this.is_loading = true
                document.body.className = 'dashboard';

                // this.charts = 
                axios.get(this.$endpoints.operasi + 'dashboard/tma_djuanda?token=' + this.token)
                .then(response => {
                    this.charts = response.data.data
                    this.is_loading = false
                });

                axios.get(this.$endpoints.operasi + 'dashboard/bendung_curug?token=' + this.token)
                .then((response) =>{
                    let width = this.$refs.spark_wrap?.clientWidth;
                    this.sparkWidth = width - 30;

                    this.curug_q1 = response.data.q1;
                    this.curug_q1.data = response.data.q1.data.map(v => v[1]);

                    this.curug_tma = response.data.tma;
                    this.curug_tma.data = response.data.tma.data.map(v => v[1]);

                    this.curug_volume = response.data.volume;
                    this.curug_volume.data = response.data.volume.data.map(v => v[1]);

                    this.curug_last_update = response.data.last_update;
                });

                axios.get(this.$endpoints.operasi + 'dashboard/data_bendung?token=' + this.token)
                .then(response => {
                    this.box_data_bendung = response.data
                });

                axios.get(this.$endpoints.operasi + 'dashboard/waduk_djuanda?token=' + this.token)
                .then(response => {
                    this.awd = response.data
                });

                axios.get(this.$endpoints.operasi + 'dashboard/debit_pab?token=' + this.token)
                .then(response => {
                    this.debit_pab = response.data
                });
            },
            getPeriodicData(){
                axios.get(this.$endpoints.reference+'periodics/all?token='+this.token)
                .then(response =>{
                    this.periodics = response.data;
                });
            },
            setEditable(e){
                e.target.contentEditable = true;
            },
            removeEditable(e){
                if(e.keyCode == 27){
                    e.target.contentEditable = false;
                }
            },
            updateHeading(e){
                if(e.keyCode == 13){
                    const k = e.target.id;
                    const v = e.target.textContent.trim();

                    e.target.contentEditable = false;
                    this.updateOption(k, v);
                }
            },
            showSelect(target){
                document.querySelector('#' + target).classList.add('show-select');
            },
            hideSelect(target){
                document.querySelector('#' + target).classList.remove('show-select');
            },
            updateColumn(key){
                const val = document.querySelector('#' + key + ' select').value;
                
                this.hideSelect(key);
                this.updateOption(key, val, () => {
                    this.is_loading = true;

                    axios.get(this.$endpoints.operasi + 'dashboard/data_bendung?token=' + this.token)
                    .then(response => {
                        this.is_loading = false;
                        this.box_data_bendung = response.data
                    });
                });
            },
            updateOption(k, v, cb){
                this.is_loading = true;

                let fd = new FormData();
                fd.append('key', k);
                fd.append('val', v);

                axios.post(this.$endpoints.operasi + 'update_option?token=' + this.token, fd)
                .then(() => {
                    this.is_loading = false;
                    cb();
                })
                .catch(e => {
                    console.log(e);
                });
            },
            zoomToSelected(){
                this.$nextTick(() => {
                    this.$refs.peta.$mapPromise.then((map) => {
                        map.panTo({lat: parseFloat(this.defaultLocation.lat), lng: parseFloat(this.defaultLocation.lng)});
                        map.setZoom(12);
                    });
                });
            },
            defineIcon()
            {
                return require('../../assets/marker/transparent.png');
            },
            defineTitle(marker){
                let latest_input_ts = moment(marker.latest_input_ts);
                let today = moment();
                let diff = today.diff(latest_input_ts, 'hours');
                let title = 'sisda-marker-';
                // title += marker._group;
                // title += '-';
                title += marker.name;
                title += (marker.id == this.selected_marker_id ? '-active':'');

                if(diff > 24 || marker.latest_input_ts == null){
                    title += '-idle';
                }else{
                    if(marker.level_siap && marker.level_siaga && marker.level_awas){
                        if(parseFloat(marker.value) >= parseFloat(marker.level_siap) && parseFloat(marker.value) < parseFloat(marker.level_siaga)){
                            title += '-l1';
                        }else if(parseFloat(marker.value) >= parseFloat(marker.level_siaga) && parseFloat(marker.value) < parseFloat(marker.level_awas)){
                            title += '-l2';
                        }else if(parseFloat(marker.value) >= parseFloat(marker.level_awas)){
                            title += '-l3';
                        }
                    }
                }

                return title;
            },
            getMap(){
                axios.get(this.$endpoints.telemeteri + 'stations/data?token=' + this.token)
                .then((response) => {
                    this.locations = response.data.locations;

                    // filter marker hitam jangan ditampilkan. lokasi yang sudah lama tidak update
                    this.locations = this.locations.filter(location => {
                        let latest_input_ts = moment(location.latest_input_ts);
                        let today = moment();
                        let diff = today.diff(latest_input_ts, 'hours');

                        return (diff < 24 && location.latest_input_ts != null);
                    });

                    // this.locations.forEach(location => {
                    //     if(!(location.wilayah in this.grouped_locations)){
                    //         this.grouped_locations[location.wilayah] = [];
                    //     }

                    //     this.grouped_locations[location.wilayah].push(location);
                    // });
                    
                    

                    this.filtered_locations = this.locations;
                    for(let i = 0; i < this.locations.length; i++){
                        
                        if(this.locations[i].level_siap && this.locations[i].level_siaga && this.locations[i].level_awas){
                            const pembanding = this.exclusive_locations.includes(this.locations[i].id) ? this.locations[i].value_mdpl:this.locations[i].value;

                            if(parseFloat(pembanding) >= parseFloat(this.locations[i].level_siap) && parseFloat(pembanding) < parseFloat(this.locations[i].level_siaga)){
                                this.siap_locations.push(this.locations[i].id);
                                this.siap_n++;
                            }else if(parseFloat(pembanding) >= parseFloat(this.locations[i].level_siaga) && parseFloat(pembanding) < parseFloat(this.locations[i].level_awas)){
                                this.siaga_locations.push(this.locations[i].id);
                                this.siaga_n++;
                            }else if(parseFloat(pembanding) >= parseFloat(this.locations[i].level_awas)){
                                this.awas_locations.push(this.locations[i].id);
                                this.awas_n++;
                            }else{
                                this.normal_n++;
                            }
                        }else{
                            this.normal_n++;
                        }
                    }

                    // set zoom to selected location

                    console.log('FILTERED', this.filtered_locations);

                    this.zoomToSelected();
                    this.is_loading = false;
                })
            },
            changeLocation(id, target)
            {
                this.is_loading = true;
                this.image = []
                this.selected_marker_id = id;

                axios.get(this.$endpoints.telemeteri + 'stations/' + id)
                .then((response) => {
                    this.defaultLocation = response.data.location;
                    this.location_name = response.data.location.name;

                    if(response.data.location._group == 'awlr'){
                        this.lokasi_pengukuran = response.data.awlrData;
                        this.defaultLocation = response.data.location;
                        this.location_name = response.data.location.name;

                        for(let i = 0; i < response.data.location.data.length; i++){
                            if(response.data.location.data[i].picture !== null){
                                this.image.push({
                                    id: response.data.location.data[i].id,
                                    picture: response.data.location.data[i].picture,
                                    ts: response.data.location.data[i].timestamps
                                });
                            }
                        }

                        let datasets;
                        if(id === 1 || id === 2 || id === 241 || id === 242) {
                            datasets = response.data.latest_data.datasets.filter(ds => ds.label.toLowerCase() === 'level (m)' || ds.label.toLowerCase() === 'siap' || ds.label.toLowerCase() === 'siaga' || ds.label.toLowerCase() === 'awas')
                        }else if(id === 3 || id === 154){
                            datasets = response.data.latest_data.datasets.filter(ds => ds.label.toLowerCase() === 'level mdpl (m)' || ds.label.toLowerCase() === 'siap' || ds.label.toLowerCase() === 'siaga' || ds.label.toLowerCase() === 'awas')
                        }else{
                            datasets = response.data.latest_data.datasets
                        }

                        this[target] = {
                            labels: response.data.latest_data.labels, 
                            datasets
                        };

                    }

                    // change chart option if necessary
                    if(response.data.location.q_formula != null){
                        this.chart_options_telemetri = {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    ticks: {
                                        autoSkip: true,
                                        maxTicksLimit: 6,
                                        maxRotation: 80,
                                        minRotation: 80,
                                        fontSize: 10
                                    }
                                }],
                                yAxes: [{
                                    display: true,
                                    position: "left",
                                    id: "y-axis-1",
                                    scaleLabel: {
                                        display: true,
                                        labelString: "meter"
                                    }
                                }, {
                                    display: true,
                                    position: "right",
                                    id: "y-axis-2",
                                    scaleLabel: {
                                        display: true,
                                        labelString: "m3/detik"
                                    }
                                }]
                            },
                            legend: {
                                labels: {
                                    boxWidth: 12
                                }
                            }
                        }
                    }else{
                        this.chart_options_telemetri = {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    ticks: {
                                        autoSkip: true,
                                        maxTicksLimit: 6,
                                        maxRotation: 80,
                                        minRotation: 80,
                                        fontSize: 10
                                    }
                                }],
                                yAxes: [{
                                    display: true,
                                    position: "left",
                                    id: "y-axis-1",
                                }]
                            },
                            legend: {
                                labels: {
                                    boxWidth: 12
                                }
                            }
                        }
                    }

                    this.zoomToSelected();
                    this.is_loading = false;
                });

            },
        },
        filters:{
            formatTime(value){
                return moment(value).format("DD MMM YYYY HH:mm")
            },
            formatShortDate(value){
                return moment(value).format("DD MMM YYYY")
            }
        },
        mounted(){
            this.getData();
            this.getDataDjuandaRealtime();
            this.getPeriodicData();
            this.changeLocation(1, 'charts_1');
            this.changeLocation(3, 'charts_2');
            this.changeLocation(2, 'charts_3');
            this.changeLocation(241, 'charts_4');
            this.changeLocation(154, 'charts_5');
            this.changeLocation(242, 'charts_6');
            this.getMap();
            this.token = localStorage.getItem('token');
            this.role = localStorage.getItem('role');
            this.access = JSON.parse(localStorage.getItem('module_access'));

            this.auto_ref = setInterval(() => {
                // this.$toasted.show('refresh data...', {
                //     duration: 3000
                // });
                this.getData();
                this.getDataDjuandaRealtime();
            }, this.$refresh_duration);
        },
        beforeDestroy(){
            clearTimeout(this.auto_ref);
        },
        unmounted(){
            console.log('clearing timeout');
        }
    }
</script>
<style scoped>
    body {
        font-family: "Open Sans", sans-serif;
        background: #f6f9ff!important;
        color: #444444;
    }

    .btn-info{
        border-radius: 10px;
        width: 100px;
    }

    .menu-icon{
        width: 70px;
    }

    [contenteditable="false"]{
        border: 0!important;
    }

    .data-column a.edit-btn,
    .data-column a.update-btn{
        visibility: hidden;
    }

    .data-column:hover a.edit-btn{
        visibility: visible;
    }

    .show-select span, 
    .show-select a.edit-btn{
        display: none;
    }

    .show-select a.update-btn{
        visibility: visible;
        display: inline;
    }

    .show-select select{
        display: block!important;
    }
</style>

<style>
    .menu-carousel .slick-prev:before,
    .menu-carousel .slick-next:before{
        color: #000!important;
    }
</style>